export default "__VITE_ASSET__4D93ntZA__"